import LoginFormClass from "./components/website/LoginFormClass";
import { handleToken } from "./components/website/sso";

window.addEventListener('DOMContentLoaded', () => {
    new LoginFormClass();
    handleToken();
});
